import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useMutation } from '../../../../../graphql/hooks';
import { CREATE_CATEGORY, GET_CATEGORIES, GET_CATEGORY_OPTIONS } from '../../../graphql';
import Query from '../../../../../graphql/Query';
import { Card, Typography } from '../../../../../ui-kit';
import { CreateCategoryFormQueryProps, OnSubmit } from './types';
import CreateCategoryFormView from './CreateCategoryFormView';


const CreateCategoryForm = () => {
    const history = useHistory();
    const [createCategory, { loading }] = useMutation(CREATE_CATEGORY, { refetchQueries: [{ query: GET_CATEGORIES }] });
    const { t } = useTranslation();
    const onSubmit: OnSubmit = async values => {
        try {
            await createCategory({ variables: values });
            history.push('/categories');
        } catch (error) {
            // nothing we can do
        }
    };

    return (
        <Query<CreateCategoryFormQueryProps> query={GET_CATEGORY_OPTIONS}>
            {({ data: { categories } }) => (
                <Card>
                    <Box px={3} py={5}>
                        <Typography variant='h6' component='h1'>{t('Create category')}</Typography>
                        <CreateCategoryFormView
                            categories={categories}
                            submitText={t('Create')}
                            onSubmit={onSubmit}
                            isLoading={loading}
                        />
                    </Box>
                </Card>
            )}
        </Query>
    );


};

export default CreateCategoryForm;
